export const ACTIVE_ORG_STORAGE_KEY = "endure:active-org-id";
export const ORG_ID_HEADER = "x-org-id";
